<template>
    <div class="AssetsLiveAccount">
        <div class="head" >
            {{$t('AccountAssets.text2')}}
            <div class="account" v-show="accountType == 1 || accountType == 3 || accountType == 4">{{$t('withdraw.text74')}}：<span>{{ accountType == 1 ?data.fundAccountName:data.mt4loginId }}</span></div>
        </div>
        <div class="line—box">
            <div class="line">
                <div class="line-item border-r">
                    <div class="item-top">
                        {{data.equity}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text3')}}
                    </div>
                </div>
                <div class="line-item border-r long_w">
                    <div class="item-top">
                        {{data.balance}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text4')}}
                    </div>
                </div>
                <div class="line-item border-r long_w">
                    <div class="item-top" :class="Number(data.dynamicProfit)>0?'up':'down'">
                        {{data.dynamicProfit}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text5')}}
                    </div>
                </div>
                <div class="line-item" v-show="accountType != 2">
                    <div class="item-top">
                        {{data.credit}}USD
                    </div>
                    <div class="item-bottom">
                       {{$t('AccountAssets.text6')}}
                    </div>
                </div>
                <div class="line-item"  :class="accountType == 3 || accountType == 4?'border-r':''" v-show="accountType == 2">
                    <div class="item-top" :class="Number(data.pnl) > 0 ?'up':'down'">
                        {{data.pnl}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text10')}}
                    </div>
                </div>
            </div>
            <div class="hr">

            </div>
             <div class="line">
                <div class="line-item border-r" v-show="accountType == 1 || accountType == 2">
                    <div class="item-top">
                        {{data.freeMargin}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text7')}}
                    </div>
                </div>
                <div class="line-item border-r long_w" v-show="accountType == 1 || accountType == 2">
                    <div class="item-top">
                        {{data.margin}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text8')}}
                    </div>
                </div>
                <div class="line-item border-r long_w" v-show="accountType == 1 || accountType == 2">
                    <div class="item-top">
                        {{data.marginRate}}
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text9')}}
                    </div>
                </div>
                <div class="line-item"  :class="accountType == 3 || accountType == 4?'border-r':''" v-show="accountType != 2">
                    <div class="item-top" :class="Number(data.pnl) > 0 ?'up':'down'">
                        {{data.pnl}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text10')}}
                    </div>
                </div>
            </div>
            <div class="hr" v-show="accountType == 1 || accountType == 2">

            </div>
             <div class="line">
                <div class="line-item border-r" v-show="accountType == 1">
                    <div class="item-top">
                        {{data.commission}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text11')}}
                    </div>
                </div>
                <div class="line-item border-r long_w" v-show="accountType == 1">
                    <div class="item-top">
                        {{data.deposit}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text12')}}
                    </div>
                </div>
                <div class="line-item border-r long_w" v-show="accountType == 1">
                    <div class="item-top">
                        {{data.withdrawl}}USD
                    </div>
                    <div class="item-bottom">
                        {{$t('AccountAssets.text13')}}
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import {
 ref,reactive,
} from 'vue';


export default {
    name:"AssetsLiveAccount",
    props:{
        data:{

        },
        accountType:{

        }
    },
    setup(){
        
        return {
        }
    }
}
</script>
<style lang="less" scoped>
.AssetsLiveAccount{
    padding: 0 30px;
    padding-bottom: 24px;
    .head{
        height: 40px;
        line-height: 40px;
        background: @bg-color;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        position: relative;
        .account{
            position: absolute;
            right: 16px;
            top:0;
            font-size: 14px;
            span{
                color: #51B4F1;
            }
        }
    }
    .line—box{
        padding-top: 14px;
    }
    .line{
        overflow: hidden;
        text-align: center;
        margin-top: 26px;
        .line-item{
            float: left;
            width: 222px;
            .item-top{
                font-size: 18px;
                font-weight: 500;
            }
            .item-bottom{
                font-size: 14px;
                color: @text-color-secondary;
            }
        }
        .long_w{
            width: 240px;
        }
        .border-r{
            border-right: 1px solid @border-color-base; /*no*/
        }
    }
    .hr{
        height: 1px; /*no*/
        background: @border-color-base;
        margin-top: 26px;
    }
}
</style>